(function () {
    'use strict';

    angular.module("imApp").factory("subscriptionUsergroupService", ['$ihttp', function ($ihttp) {
        let service = {
            listSubscriptionUserGroups: function (parms) {
                return $ihttp.post({
                    method: 111,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
